/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  BodyChunkedUploadPublicDatasetFile,
  ChunkedUploadPublicDatasetFileParams,
  PublicDatasetResponse,
  RequestBodyFileUpload,
  UploadPublicDatasetFileParams,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({providedIn: 'root'})
export class PublicDatasetFileService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Takes in a public dataset file and creates a PublicDataset and File record in the DB
   * File is uploaded to public storage and dataverse. Requires user to provide dataset file due to firewall
   * rules
   * @summary Upload Public Dataset File
   */
  uploadPublicDatasetFile<TData = PublicDatasetResponse>(
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadPublicDatasetFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  uploadPublicDatasetFile<TData = PublicDatasetResponse>(
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadPublicDatasetFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  uploadPublicDatasetFile<TData = PublicDatasetResponse>(
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadPublicDatasetFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  uploadPublicDatasetFile<TData = PublicDatasetResponse>(
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadPublicDatasetFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const formData = new FormData();
    formData.append(`file`, requestBodyFileUpload.file);

    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/public-dataset-file`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/public-dataset-file`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/public-dataset-file`, formData, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Handles the upload of public dataset files in chunks.
   *
   * This endpoint is intended exclusively for front-end use to bypass firewall restrictions.
   * Typically, users would download dataset files from the backend and manually re-upload them
   * to public storage. This endpoint streamlines that process, particularly for large files
   * that cannot be stored entirely in browser memory by enabling chunked uploads.
   *
   * **Key Details:**
   * - Designed for large files, allowing upload in smaller chunks to accommodate limited browser memory.
   * - Front-end must first download the file from the backend using the `download_stored_format` flag
   *   set to `true`. This ensures the file is compressed if needed, optimizing the file transfer process.
   *
   * Query Parameters:
   * - `dataset_id`: Dataset ID (UUID) that file is part of.
   * - `storage_organization`: name of the organization that host the dataset file.
   * - `upload_id`: UUID provided by client to ensure each file upload session is distinct.
   * - `chunk_number`: The index of the current chunk (starting from 1).
   * - `finalize`: Used to indicate the upload is complete so that file is uploaded to public storage.
   * @summary Chunked Upload Public Dataset File
   */
  chunkedUploadPublicDatasetFile<TData = unknown>(
    bodyChunkedUploadPublicDatasetFile: BodyChunkedUploadPublicDatasetFile,
    params: ChunkedUploadPublicDatasetFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  chunkedUploadPublicDatasetFile<TData = unknown>(
    bodyChunkedUploadPublicDatasetFile: BodyChunkedUploadPublicDatasetFile,
    params: ChunkedUploadPublicDatasetFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  chunkedUploadPublicDatasetFile<TData = unknown>(
    bodyChunkedUploadPublicDatasetFile: BodyChunkedUploadPublicDatasetFile,
    params: ChunkedUploadPublicDatasetFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  chunkedUploadPublicDatasetFile<TData = unknown>(
    bodyChunkedUploadPublicDatasetFile: BodyChunkedUploadPublicDatasetFile,
    params: ChunkedUploadPublicDatasetFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const formData = new FormData();
    formData.append(`file`, bodyChunkedUploadPublicDatasetFile.file);

    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/public-dataset-file/chunked-upload`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/public-dataset-file/chunked-upload`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/public-dataset-file/chunked-upload`, formData, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Deletes public dataset file. For use by users with special permissions. Note: If a
   * user wants to delete their public dataset file, they should mark it as private in their
   * data enclave. The sync endpoint will then be called by the front-end and the file will
   * be removed
   * @summary Delete Public Dataset File
   */
  deletePublicDatasetFile<TData = unknown>(datasetId: string, options?: HttpClientBodyOptions): Observable<TData>;
  deletePublicDatasetFile<TData = unknown>(
    datasetId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deletePublicDatasetFile<TData = unknown>(
    datasetId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deletePublicDatasetFile<TData = unknown>(
    datasetId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/api/public-dataset-file/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/api/public-dataset-file/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/api/public-dataset-file/${datasetId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Returns metadata for a public dataset file
   * @summary Get Public Dataset File Metadata
   */
  getPublicDatasetFile<TData = PublicDatasetResponse>(
    datasetId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getPublicDatasetFile<TData = PublicDatasetResponse>(
    datasetId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getPublicDatasetFile<TData = PublicDatasetResponse>(
    datasetId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getPublicDatasetFile<TData = PublicDatasetResponse>(
    datasetId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/public-dataset-file/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/public-dataset-file/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/public-dataset-file/${datasetId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
